import * as yup from 'yup';
import yupLocalePtBr from '~utils/yupLocalePtBr';
import cellphone from './cellphone';
import cpf from './cpf';
import name from './name';
import birthdayDate from './birthdayDate';
import atLeastOneCharacter from './atLeastOneCharacter';
import atLeastOneNumber from './atLeastOneNumber';
import atLeastOneSimbol from './atLeastOneSimbol';
import zipCode from './zipCode';
import fileSize from './fileSize';
import pdf from './pdf';
import positiveNumber from './positiveNumber';

yup.addMethod(yup.string, 'birthdayDate', birthdayDate);
yup.addMethod(yup.string, 'zipCode', zipCode);
yup.addMethod(yup.string, 'name', name);
yup.addMethod(yup.string, 'cpf', cpf);
yup.addMethod(yup.string, 'cellphone', cellphone);
yup.addMethod(yup.string, 'atLeastOneNumber', atLeastOneNumber);
yup.addMethod(yup.string, 'atLeastOneCharacter', atLeastOneCharacter);
yup.addMethod(yup.string, 'atLeastOneSimbol', atLeastOneSimbol);
yup.addMethod(yup.mixed, 'pdf', pdf);
yup.addMethod(yup.mixed, 'fileSize', fileSize);
yup.addMethod(yup.string, 'positiveNumber', positiveNumber);
yup.setLocale(yupLocalePtBr);

export * from 'yup';
